
export const AUTH_LOGOUT = 'Successfully logged out.';
